module.exports = __webpack_public_path__ + "static/media/400063_01.ebb87df4.png";